import type {
  ResidentApplication,
  ProviderApplication,
  VolunteerApplication,
  HireRequest,
  MowDay,
  MowDaySignup,
} from './types';

export interface ApiSuccess<T = unknown> {
  ok: true;
  data: T;
}
export interface ApiError {
  ok: false;
  error: string;
  details?: Record<string, string>;
}
export type ApiResult<T = unknown> = ApiSuccess<T> | ApiError;

async function postJson<T>(url: string, body: unknown): Promise<ApiResult<T>> {
  try {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    const json = (await res.json()) as ApiResult<T>;
    return json;
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : 'Network error' };
  }
}

async function getJson<T>(url: string): Promise<ApiResult<T>> {
  try {
    const res = await fetch(url, { credentials: 'include' });
    const json = (await res.json()) as ApiResult<T>;
    return json;
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : 'Network error' };
  }
}

export const submitResident = (data: ResidentApplication) =>
  postJson<{ id: number; score: number; tier: string; cycle_end: string }>('/api/resident', data);

export const submitProvider = (data: ProviderApplication) =>
  postJson<{ id: number }>('/api/provider', data);

export const submitVolunteer = (data: VolunteerApplication) =>
  postJson<{ id: number }>('/api/volunteer', data);

export const submitHire = (data: HireRequest) =>
  postJson<{ id: number }>('/api/hire', data);

export const listUpcomingMowDays = () =>
  getJson<{ mow_days: MowDay[] }>('/api/mow-days');

export const signupForMowDay = (data: MowDaySignup) =>
  postJson<{ id: number }>('/api/mow-day-signup', data);
